import React from 'react';
import PortalTabs from './PortalTabs';
const items=[
 {id:'Dashboard',label:'Dashboard',path:'/owner-dashboard'},
 {id:'Fleet',label:'Fleet',path:'/fleet'},
 {id:'Bookings',label:'Bookings',path:'/owner/bookings'},
 {id:'Financials',label:'Financials',path:'/finances'},
];
export default function OwnerTopNav({activePage}){return <div className="mb-5"><PortalTabs items={items} active={activePage} label="Car owner portal sections"/></div>;}
